<template>
  <div >
    <v-card flat class="px-2" v-if="value && value.length > 0">
      <v-card-subtitle v-if="showTitle" class="text-decoration-underline pa-0">
        {{ $t("portfolio.comment.plural") }}
      </v-card-subtitle>
      <v-card-text>
        <v-card
          flat
          :color="$vuetify.theme.dark ? '#182a36' : '#ebf7ff'"
          v-for="comment in value"
          :key="comment.commentGuid"
          class="pa-3 ma-2"
        >
          <v-row>
            <profileImage
              :size="32"
              classCss="mt-3"
              :displayName="
                comment.personType == 0
                  ? comment.student.studentFullName
                  : comment.teacher.teacherName
              "
              :thumbnail="true"
              :imageUrl="comment.personType == 0 ? comment.student.profileImageUrl : null"
            />
            <v-spacer></v-spacer>

            <v-chip
              class="ma-2"
              small
              outlined
              label
              :title="comment.createdDate | moment('YYYY/MM/DD - h:mm A')"
            >
              {{ dateFromNow(comment.createdDate) }}
              <v-icon
                v-if="comment.modifiedDate"
                small
                class="ms-1"
                :title="
                  `${$t('portfolio.general.modifiedDate')}: ${$options.filters.moment(
                    comment.modifiedDate,
                    'YYYY/MM/DD - h:mm A'
                  )}`
                "
                >mdi-pencil</v-icon
              >
            </v-chip>
          </v-row>
          <v-card-text class="pa-3" dir="auto">
            <div>{{ comment.commentText }}</div>
          </v-card-text>
          <div class="d-flex justify-space-between align-center " style="margin-bottom: 0;">
            <div>
              <v-btn
                text
                small
                v-if="isOwner(comment)"
                color="primary"
                @click="$refs.commentsDialog.showEditDialog(comment)"
              >
                <v-icon left>mdi-pencil</v-icon>
                {{ $t("edit") }}
              </v-btn>
              <v-btn
                v-if="isOwner(comment)"
                text
                small
                color="red"
                @click="
                  activeComment = comment;
                  $refs.confirmActionDialog.showDialog();
                "
              >
                <v-icon left>mdi-delete</v-icon>
                {{ $t("delete") }}
              </v-btn>
            </div>
          </div>
        </v-card>
      </v-card-text>
    </v-card>
    <noData v-else-if="showNoData && !loading" />

    <CommentsDialog ref="commentsDialog" @edit="editCommentHandler" />

    <ConfirmActionDialog
      ref="confirmActionDialog"
      :title="$t('portfolio.comment.delete')"
      :description="$t('portfolio.comment.deleteConform')"
      @confirm="handleConfirmDeleteAction"
    />
  </div>
</template>

<script>
import ConfirmActionDialog from "../../confirmActionDialog.vue";
import CommentsDialog from "./commentsDialog.vue";
import NoData from "../../noData.vue";
import LoadingData from "../../loadingData.vue";
import profileImage from "../profileImage.vue";

export default {
  name: "Comments",

  components: {
    ConfirmActionDialog,
    CommentsDialog,
    NoData,
    LoadingData,
    profileImage
  },
  props: {
    sourceType: {
      type: String || Number,
      required: true
    },
    sourceGuid: {
      type: String,
      required: true
    },
    showNoData: {
      type: Boolean,
      default: false
    },
    showTitle: {
      type: Boolean,
      default: true
    },
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loading: false,
      activeComment: null
    };
  },
  async mounted() {
    this.$commentsHub.joinGroup(this.sourceGuid);
    this.$commentsHub.deleteComment(x => {
      if (x.sourceGuid !== this.sourceGuid) return;
      const index = this.value.findIndex(c => c.commentGuid === x.commentGuid);
      if (index !== -1) {
        this.value.splice(index, 1);
      }
    });
    this.$commentsHub.updateComment(x => {
      if (x.sourceGuid !== this.sourceGuid) return;
      const index = this.value.findIndex(c => c.commentGuid === x.commentGuid);
      if (index !== -1) {
        Object.assign(this.value[index], x);
      }
    });
    this.$commentsHub.createComment(x => {
      if (x.sourceGuid !== this.sourceGuid) return;

      this.addComment(x);
    });
  },
  async unmounted() {
    this.$commentsHub.leaveGroup(this.sourceGuid);
  },

  methods: {
    handleConfirmDeleteAction() {
      this.axios
        .post(`Comment/Delete`, { commentGuid: this.activeComment.commentGuid })
        .then(() => {
          const index = this.value.findIndex(c => c.commentGuid === this.activeComment.commentGuid);
          if (index !== -1) {
            this.value.splice(index, 1);
          }

          this.$emit("input", this.value);
          this.$forceUpdate();
        })
        .catch(error => {
          console.error(error);
        });
    },

    addComment(comment) {
      const index = this.value.findIndex(c => c.commentGuid === comment.commentGuid);
      if (index !== -1) {
        this.value[index].commentText = comment.commentText;
      } else {
        this.value.unshift(comment);
      }
      this.$emit("input", this.value);
      this.$forceUpdate();
    },
    isOwner(comment) {
      return comment.personType === 0
        ? comment.student.studentGuid === this.$store.state.userData.guid
        : comment.teacher.teacherGuid === this.$store.state.userData.guid;
    },
    editCommentHandler(comment) {
      const index = this.value.findIndex(c => c.commentGuid === comment.commentGuid);
      if (index !== -1) {
        this.value[index].commentText = comment.commentText;
        this.value[index].modifiedDate = new Date();
        this.$emit("input", this.value);
      }
      this.$forceUpdate();
    }
  }
};
</script>

<style scoped>
.mt-4 {
  margin-top: 16px;
}
</style>
